import React, { useEffect, useState } from "react";
import { Card, Row, Col, DropdownButton, Dropdown } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import LeaderBoard from "../../Components/LeaderBoard";

import Banner from "../../Components/Banner";
import DashboardLayout from "../DashboardLayout";
import { useAppContext } from "../../services/context";
import { fetchDashboardData } from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import BarGraph from "./barGraph";
import LineGraph from "./lineGraph";
import { ensureNotificationSubscription } from "../../services/onesignal";

function Dashboard() {
  const navigate = useNavigate();
  const { state, setState } = useAppContext();
  const { dashboardData, user } = state;

  const [filter, setFilter] = useState("day");
  const getDashBoardData = async () => {
    const res = await fetchDashboardData();
    if (res?.data?.success && res?.data?.data) {
      setState((prev) => ({ ...prev, dashboardData: res.data.data }));
    } else {
      await handleErrors(res, navigate, true);
    }
  };

  useEffect(() => {
    getDashBoardData();
    ensureNotificationSubscription(setState);
  }, []);
  const totalUsers = 2000;
  const totalGames = 150;
  const totalEmployees = 300;
  const totalDonations = 500;

  const pieData = {
    labels: ["Users", "Games", "Employees", "Donations"],
    datasets: [
      {
        label: "Distribution",
        data: [totalUsers, totalGames, totalEmployees, totalDonations],
        backgroundColor: ["#28a745", "#17a2b8", "#8e24aa", "#f39c12"],
        borderWidth: 1,
      },
    ],
  };

  const data = {
    labels:
      filter === "day"
        ? ["1", "2", "3", "4", "5", "6", "7"]
        : filter === "week"
          ? ["Week 1", "Week 2", "Week 3", "Week 4"]
          : ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [
      {
        label: "Donations",
        data:
          filter === "day"
            ? [12, 19, 3, 5, 2, 3, 7]
            : filter === "week"
              ? [55, 60, 70, 85]
              : [75, 80, 95, 100, 110, 130, 145],
        borderColor: "#28a745",
        backgroundColor: "rgba(40, 167, 69, 0.2)",
        fill: true,
      },
      {
        label: "Users",
        data:
          filter === "day"
            ? [8, 15, 7, 10, 13, 5, 6]
            : filter === "week"
              ? [30, 35, 40, 45]
              : [50, 55, 60, 65, 70, 80, 90],
        borderColor: "#17a2b8",
        backgroundColor: "rgba(23, 162, 184, 0.2)",
        fill: true,
      },
    ],
  };

  return (
    <DashboardLayout>
      <div>
        <Banner />
        <Row>
          {["Total Users", "Total Games", "Total Employees"].map(
            (title, index) => (
              <Col
                xs={12}
                sm={6}
                md={4}
                key={index}
                className="d-flex justify-content-center mb-4"
              >
                <Card
                  className="bg-dark text-white"
                  style={{
                    width: "100%",
                    maxWidth: "394px",
                    borderRadius: "15px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
                    background: "linear-gradient(to right, #8e24aa, #12955E)",
                    padding: "20px",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer",
                    border: "none",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.03)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  <Card.Body>
                    <Card.Title
                      style={{
                        fontSize: "1.25rem",
                        fontWeight: "700",
                        letterSpacing: "0.5px",
                      }}
                    >
                      {title}
                    </Card.Title>
                    <Card.Text
                      style={{
                        fontSize: "2rem",
                        fontWeight: "700",
                        letterSpacing: "1px",
                      }}
                    >
                      {index === 0
                        ? dashboardData?.total_users || 0
                        : index === 1
                          ? dashboardData?.total_games || 0
                          : dashboardData?.total_employees || 0}
                    </Card.Text>
                    <Card.Text
                      style={{
                        fontSize: "1rem",
                        fontWeight: "400",
                        color: "rgba(255, 255, 255, 0.7)",
                        marginTop: "10px",
                      }}
                    >
                      {index === 0
                        ? "The total number of registered users on the platform."
                        : index === 1
                          ? "The total number of games available on the platform."
                          : "The total number of employees working in the company."}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            )
          )}
        </Row>
        <Row className="mb-4">
          <Col>
            <DropdownButton
              id="dropdown-basic-button"
              className="btn-success text-white"
              title={`Filter by ${filter}`}
              onSelect={(e) => setFilter(e)}
              style={{
                borderRadius: "30px",
                padding: "10px 20px",
                fontSize: "1.1rem",
              }}
            >
              <Dropdown.Item eventKey="day">Day</Dropdown.Item>
              <Dropdown.Item eventKey="week">Week</Dropdown.Item>
              <Dropdown.Item eventKey="month">Month</Dropdown.Item>
            </DropdownButton>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Card
              className="bg-dark text-white mb-4"
              style={{
                borderRadius: "15px",
                width: "100%",
                height: "500px",
                margin: "auto",
              }}
            >
              <Card.Body
                className="d-flex flex-column"
                style={{ padding: "20px" }}
              >
                <Card.Title>Traffic Data ({filter})</Card.Title>
                <div style={{ flex: 1, overflow: "hidden" }}>
                  <Line data={data} options={{ maintainAspectRatio: false }} />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <LineGraph />
          <BarGraph />
        </Row>

        <div className="row">
          <div className="col-12">
            <LeaderBoard />
          </div>
        </div>
        {/* <div className="d-flex align-items-center gap-2 row col-md-12 col-lg-12">
          <LeaderBoard />
        </div> */}
      </div>
    </DashboardLayout>
  );
}
export default Dashboard;
